import Vue from 'vue';
import axios from 'axios';

const AsyncTemplate = Vue.component('async-template', function(resolve) {
  resolve({
    name: 'async-template',
    props: {
      url: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        template: '<p class="color-silver">Loading...</p>',
      }
    },
    mounted() {
      axios.get(this.url, {
        params: this.params || null,
        headers: {
          'Accept': 'text/html',
        },
      })
        .then(({ data }) => {
          // updating the data triggers a render
          this.template = data;
        });
    },
    render(createElement) {
      // create a wrapper for the response HTML
      const compiledTemplate = Vue.compile(`<div
        class="async-template"
        data-url="${this.url}"
        v-html="template"></div>`);
      return compiledTemplate.render.call(this, createElement);
    },
  });
});

const AsyncAsyncTemplate = () => ({
  component: AsyncTemplate,
  // A component to use while the async component is loading
  loading: import('Components/Loading.vue'),
  // A component to use if the load fails
  error: null,
})

export default AsyncAsyncTemplate;



// WEBPACK FOOTER //
// ./resources/assets/js/async-template.js